export default __webpack_public_path__ + "static/media/Snd_LowerNSwim.abddee25.mp3";